/**
 * Mapping for translation keys, so we don't have to use long text in source code. Please keep in mind, that the
 * german default translations are the keys, so don't change them, if you wan't to change the text.
 * Instead change the de_DE translations!
 */
export const KEYS = {
  GRID: {
    THIEME_CATALOG: 'Thieme Vorlagen',
    CATALOG: 'Katalog',
    SEARCH: 'Suche',
    FULLTEXT: 'Bogencode / Kurztitel',
    BOGENCODE: 'Bogencode',
    SHORT_TITLE: 'Kurztitel',
    SPECIALTY: 'Fachbereich',
    BODY_REGION: 'Körperregion',
    FORM_TYPE: 'Bogentyp',
    LANGUAGE: 'Sprache',
    DOWNLOAD_STATUS: 'Import-Status',
    DOWNLOAD_STATUS_DOWNLOADED: 'Bereits importiert',
    VERSION: 'Version',
    STATUS: 'Status',
    OPTIONS: 'Optionen',
    DOWNLOAD: 'Importieren',
    ENTRIES: 'Einträge',
    CATALOG_VERSION: 'Katalog-Version',
    STATUS_NOT_DOWNLOADED: 'Noch nicht importiert',
    STATUS_UP_TO_DATE: 'Aktuell',
    STATUS_UPDATE_AVAILABLE: 'Update verfügbar - neue Version: [[version]]',
    SUCCESSFULLY_IMPORTED: 'Der Bogen wurde erfolgreich importiert.',
    ERROR_IMPORTING: 'Beim Import des Bogens ist ein Fehler aufgetreten!',
    ERROR_LOADING_CATALOG: 'Beim Laden des Thieme-Katalogs ist ein Fehler aufgetreten!',
    ERROR_LICENSE: 'Der Katalog konnte nicht geladen werden. Bitte prüfen Sie die Thieme-Lizenz der Instanz.',
    CONFIG_ERROR: 'Konfigurationsfehler',
    ERROR_MISSING_MANDATORY_CONFIG: 'Die URL zur Thieme-Connector API wurde nicht konfiguriert!',
    INCOMPATIBLE_REMOTE: 'Ein neuer Thieme-Katalog ([[version]]) ist verfügbar, benötigt aber ein myMedax-Update '
      + '(Bogenformat [[schemaVersion]]). Bis dahin bleibt der Katalog auf dem aktuellen Stand.'
  }
};
